<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Convidado
  </app-header-dialog>

  <div class="main-area">

    <div class="left-area">
      <img [src]="data.image">
    </div>

    <div class="right-area">

      <div>
        <img style="width: 20px;" [src]="data.flag">
      </div>

      <div style="font-size: 1.4em; color:rgb(2, 2, 57)">
        {{data.name}}
      </div>

      <div style="margin-top: 20px; padding: 10px;" [innerHTML]='data.text'>
      </div>
      <hr>
      <div *ngIf="data.activities.length !== 0">
        <div style="margin-top: 20px; font-size: 1.2em; color:rgb(2, 2, 57)">Atividades</div>
        <hr>
        <div style="margin-top: 5px;" *ngFor="let activity of data.activities">

          <ul>
            <li>{{activity.day_date}}</li>
            <li>{{activity.activity_startTime}}</li>
            <li>{{activity.location}}</li>
            <li>{{activity.role_name}}</li>
            <li>{{activity.activity_name}}</li>
          </ul>
          <hr>
        </div>
      </div>

      <div *ngIf="data.topics.length !== 0">
        <div style="margin-top: 20px; font-size: 1.2em; color:rgb(2, 2, 57)">Tópicos</div>
        <hr>
        <div style="margin-top: 5px;" *ngFor="let topic of data.topics">

          <ul>
            <li>{{topic.day_date}}</li>
            <li>{{topic.topic_startTime}}</li>
            <li>{{topic.location}}</li>
            <li>{{topic.role_name}}</li>
            <li>{{topic.activity_name}}</li>
            <li>{{topic.topic_name}}</li>
            <li>{{topic.topic_duration}} min.</li>
          </ul>
          <hr>
        </div>
      </div>

    </div>
  </div>

</div>